<template>
  <base-badge :right="right">
    <template v-slot:avatar>
      <person-avatar :person="prospect.contact" />
    </template>
    <template v-slot:first-line>
      <span class="primary-text-color font-weight-bold main-name">
        {{prospect.contact.firstName}} {{prospect.contact.lastName || ''}}
      </span>
    </template>
    <template v-slot:second-line>
      <span class="text-core-onCore-lowEmphasis!">
        <span v-if="prospect.isProspectFrom.eko">Ekspert Kredytowy Online •</span>
        {{ dateFormat(prospect.contact.createdAt) }}
      </span>
    </template>
  </base-badge>
</template>

<script lang="ts">
import {Component, Prop} from 'vue-property-decorator';
import BaseBadge from '@/components/badges/base/BaseBadge.vue';
import PersonAvatar from '@/components/commons/PersonAvatar.vue';
import {Prospect} from '@/models/Prospect';
import { dateFormat } from '@/composables/useFilters';

@Component({
  components: {PersonAvatar, BaseBadge, },
})
export default class ProspectBadge extends BaseBadge {
  public dateFormat = dateFormat;

  @Prop({required: true, }) prospect!: Prospect;
}
</script>

<style scoped lang="scss">
  .initials-style{
    color: var(--token-primary-surface);
    text-align: center;
    justify-content: center
  }
</style>
